/* global angular */

angular.module('ui-rangeSlider', [])
.directive('rangeSlider', [
'$log',
'$window',
'$document',
'$timeout',
function($log, $window, $document, $timeout) {
  'use strict';

  function offsetTop(el){
    return el.getBoundingClientRect().top + scrollTop();
  }

  function scrollTop(){
    return $window.pageYOffset ||
           $document[0].documentElement.scrollTop ||
           $document[0].body.scrollTop ||
           0;
  }

  return {
    restrict : 'EA',
    replace : true,
    scope : {
      start: '=',
      end: '=',
      step: '=',
      sliderValue: '=',
      slided: '&'
    },
    link: function(scope, element, attrs) {
      var isHorizontal = element.hasClass('is-horizontal');
      var bar = element.find('span');
      var step = parseInt(attrs.step, 10) || 1;
      var percent;

      scope.update = function() {
        percent = ((scope.sliderValue - scope.start) * 100) / (scope.end - scope.start);
        bar.css(isHorizontal ? 'width' : 'height', percent + '%');
      };

      scope.$watch('sliderValue', function(newVal, oldVal) {
        if (newVal !== oldVal) scope.update();
      });

      // we need to add a timeout to fix bug on iOS (in overlay mode) where the page
      // scroll at the very top
      $timeout(function() {
        scope.update();
      });

      var offset;
      var height;
      var width;
      var fval;
      var isDragging;
      var forceUpdate;

      element.on('mousedown touchstart', function(evt) {
        var slider = element[0].querySelector('.gc-slider-enlarger');
        var computedStyle = getComputedStyle(slider);

        if (isHorizontal) {
          width = slider.getBoundingClientRect().width;
          width -= parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight);
          offset = slider.getBoundingClientRect().left;
          offset += parseFloat(computedStyle.paddingLeft);
        } else {
          height = slider.getBoundingClientRect().height;
          height -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);
          offset = slider.getBoundingClientRect().top;
          offset += parseFloat(computedStyle.paddingTop);
        }

        forceUpdate = true;
        updateCursor(evt);
        isDragging = true;
      });

      element.on('mousemove touchmove', updateCursor);

      element.on('mouseup touchend', stopDrag);

      $window.addEventListener('mouseup', stopDrag);

      // element.on('mouseleave', function() {
      //   isDragging = false;
      // });

      function updateCursor(evt){
        if (!isDragging && !forceUpdate) {
          evt.preventDefault();
          return;
        }

        forceUpdate = false;
        if (isHorizontal) {
          var x = (evt.clientX || evt.changedTouches[0].clientX) - offset;
          var percent = x / width;
        } else {
          var y = (evt.clientY || evt.changedTouches[0].clientY) - offset;
          var percent = y / height;
        }

        // keep `percent` between 0 and 1
        percent = Math.max(0, Math.min(1, percent));

        // apply steps
        var fromStart = Math.round(percent * 100);
        var modulo = fromStart % step;
        if (modulo !== 0) {
          if (modulo < step / 2) fromStart -= modulo;
          else fromStart += step - modulo;
        }
        percent = fromStart / 100;

        var range = Math.abs(scope.end - scope.start / step) * step;
        fval = Math.min(100 / (range / Math.round(percent * range)), 100)

        bar.css(isHorizontal ? 'width': 'height', fval + '%');
        evt.preventDefault();
      }

      function stopDrag(/*evt*/){
        if (!isDragging) {
          return;
        }

        $timeout(function(){
          var sliderValue = Math.round(((fval * (scope.end - scope.start)) / 100) + scope.start);

          // apply steps
          var modulo = sliderValue % step;
          if (modulo !== 0) {
            if (modulo < step / 2) sliderValue -= modulo;
            else sliderValue += step - modulo;
          }

          scope.slided({ value: sliderValue });
        });

        isDragging = false;
      }

    }
  };
}]);
